import { styled, useTheme } from '@vebox/etui-system';
import { createElement } from 'react';
import '../../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div, Span } from '@vebox/etui-system-elements';
import '../../Svg-0180d7b5.js';
import Icon from '../../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../../Icon/icons.js';
import '../../Icon/helper.js';

const EmptyPlaceholderWrapper = styled(Div)`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const EmptyPlaceholderLabel = styled(Span)`
  color: ${({
  theme
}) => theme.palette.grey[60]};
  margin-top: ${({
  theme
}) => theme.spacing.md}px;
`;

const EmptyPlaceholder = ({
  label
}) => {
  const theme = useTheme();
  return /*#__PURE__*/createElement(EmptyPlaceholderWrapper, null, /*#__PURE__*/createElement(Icon, {
    glyph: icons.INFO_CIRCLE,
    size: 32,
    styles: {
      root: {
        color: theme.palette.black[10]
      }
    }
  }), /*#__PURE__*/createElement(EmptyPlaceholderLabel, null, label));
};

export default EmptyPlaceholder;
